import { Component, Input } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { select, Store } from '@ngrx/store'
import * as lodash from 'lodash'
import { selectAllUsers, User, userFullname } from '@tokeet-frontend/tv3-platform'

@Component({
  selector: 'app-document-user-notifications',
  templateUrl: './document-user-notifications.component.html',
  styles: [],
})
export class DocumentUserNotificationsComponent {
  @Input() form: FormGroup
  @Input() receiverForm: FormGroup

  users$ = this.store.pipe(select(selectAllUsers))
  constructor(private store: Store<any>) {}

  onUserSelect(users: User[]) {
    const user = lodash.head(users)
    this.receiverForm.patchValue({ email: user?.primaryEmail, name: userFullname(user) }, { emitEvent: false })
  }
}
